import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cancel-1",
  "use": "cancel-1-usage",
  "viewBox": "0 0 768 768",
  "content": "<symbol viewBox=\"0 0 768 768\" id=\"cancel-1\"><path d=\"M384 128c-141.152 0-256 114.848-256 256s114.848 256 256 256 256-114.848 256-256-114.848-256-256-256zM224 384c0-26.624 7.168-51.328 18.688-73.44L457.44 525.312C435.328 536.832 410.624 544 384 544c-88.224 0-160-71.776-160-160zm301.312 73.44L310.56 242.688C332.672 231.168 357.376 224 384 224c88.224 0 160 71.776 160 160 0 26.624-7.168 51.328-18.688 73.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/cancel-1.svg
// module id = Gyro
// module chunks = 1